// extracted by mini-css-extract-plugin
export var buttonUp = "style-module--buttonUp--84b7d";
export var faqItem = "style-module--faqItem--b790c";
export var form = "style-module--form--5086f";
export var formContent = "style-module--formContent--6accf";
export var formDesc = "style-module--formDesc--61e19";
export var formPic = "style-module--formPic--8f9cb";
export var formPicSecond = "style-module--formPicSecond--e468b";
export var formSection = "style-module--formSection--55c32";
export var formWrap = "style-module--formWrap--eb509";
export var highlight = "style-module--highlight--b46b1";
export var highlightDecor = "style-module--highlightDecor--868e5";
export var pagePrice = "style-module--pagePrice--1342a";
export var questions = "style-module--questions--caa0c";
export var wrapper = "style-module--wrapper--936f5";